export let routes = [
  {
    path: '/x3-side-approval-opinion',
    name: 'x3-side-approval-opinion',
    component: () => import('./opinion.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsApprovalOpinion(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-approval-opinion',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};

// 填写信息确认侧边组件

// 使用示例
// 单个表单选项使用示例
// app.x3.side.xsApprovalOpinion({
//   config: {
//     pageTitle: '同意请假', // 侧边选择页面的标题，可缺省，默认'同意请假'
//     cancelText: '取消', // 侧边选择页面取消按钮文本，可缺省，默认'取消'
//     confirmText: '确认', // 侧边选择页面确认按钮文本，可缺省，默认'取消'
//     showCancelButton: true, // 侧边选择页面取消按钮是否显示，可缺省，默认true, 展示
//     formInputAlign: 'right', // 侧边选择页面表单整体对齐方式，可缺省，默认'right'
//   }, 
//   // field为要展示的表单项，默认一个textarea
//   field: {
//     prop: 'reason', // 表单属性名称，确认时会返回一个对象，以该属性返回值，该属性缺省后默认为name+[缺省的表单项的序号]，如name1
//     type: 'textarea', // 表单类型，默认textarea, 支持：switch、checkbox、checkboxGrounp、radio、picker和基础输入表单
//     defaultValue: '', // 表单默认值
//     // 表单相应的属性，会直接通过v-bind绑定到vant表单组件上，具体可查看vant的具体表单项配置
//     attrs: {
//       placeholder: '请输入审批意见（选填）',
//       showWordLimit: true,
//       maxlength: 200,
//       rows: 4,
//       inputAlign: "left"
//     },
//       /**
//        * 校验当天表单项
//        * @param val 当前选项值
//        * @param formDatas 整个表单的值
//        * @return Boolean ,如果没有返回true、就不会通过验证
//        */
//       validate: (val, formDatas) => {
//         if (val===undefined || val===null || val === '') {
//           app.vue.$toast.fail('请填写输入1选项值')
//         }
//       }
//     },
//   },
// })

// 多个表单项使用示例
// 多个表单可使用fields，
// app.x3.side.xsApprovalOpinion({
//   config: {pageTitle: '侧边确认表单测试'}, 
//   fields: [
//     {
//       type: 'number',
//       prop: 'name1',  // 该属性缺省后默认为name+[缺省的表单项的序号]，如name1
//       attrs: {
//         required: true, /** 些属性仅仅用于添加必填图标，校验使用validate */
//         label: "输入1",
//         placeholder: '请输入'
//       },
//       /**
//        * 校验当天表单项
//        * @param val 当前选项值
//        * @param formDatas 整个表单的值
//        * @return Boolean ,如果没有返回true、就不会通过验证
//        */
//       validate: (val, formDatas) => {
//         if (val===undefined || val===null || val === '') {
//           app.vue.$toast.fail('请填写输入1选项值')
//         }
//         return true;
//       }
//     },
//     {
//       type: 'switch', 
//       defaultValue: true, 
//       prop: 'name2', 
//       attrs: {
//         label:'开关'
//       }, 
//     },
//     {
//       type: 'checkbox', 
//       defaultValue: true, 
//       prop: 'name3', 
//       attrs: {
//         label: '复选框1',
//         shape: "square",
//         text: '选这个', // 复选框后的文本
//       }, 
//     },
//     // 复选框组
//     {
//       type: 'checkboxGrounp', 
//       defaultValue: [1], 
//       prop: 'name4', 
//       attrs: {
//         label: '复选框组',
//       }, 
//       // 复选框组的选项，必需
//       checkboxes: [
//         {
//           name: 1,
//           text: '选项1'
//         },
//         {
//           name: 2,
//           text: '选项2',
//           attrs: {            
//             shape: "square",
//           }
//         }
//       ]
//     },
//     // 单选框组
//     {
//       type: 'radio', 
//       defaultValue: 2, 
//       prop: 'radio', 
//       attrs: {
//         label: '单选框组',
//       }, 
//       // 复选框组的选项，必需
//       options: [
//         {
//           name: 1,
//           text: '选项1'
//         },
//         {
//           name: 2,
//           text: '选项2',
//         }
//       ]
//     },
//     // picker选择框
//     {
//       type: 'picker', 
//       defaultValue: '绍兴', 
//       prop: 'name5', 
//       attrs: {
//         label: '城市',
//       }, 
//       options: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      
//       popupAttrs: {}, // 设置选择popup弹窗属性
//       pickerAttrs: {title: '选择城市'} // 设置选择popup弹窗里面的picker属性
//     },
//     {
//       type: 'picker', 
//       defaultValue:  {
//         text: '西瓜',
//         id: 3
//       },
//       prop: 'name6', 
//       attrs: {
//         label: '喜欢的水果',
//         placeholder: '请告诉我你喜欢的水果'
//       }, 
//       pickerAttrs: {title: '选择水果'},
//       options: [
//           {
//             text: '菜果',
//             id: 1
//           },
//           {
//             text: '香蕉',
//             id: 2
//           },
//           {
//             text: '西瓜',
//             id: 3
//           },
//           {
//             text: '小孩子才做选择',
//             id: 4
//           }
//       ]
//     },
//     {
//       type: 'picker', 
//       prop: 'name7', 
//       attrs: {
//         label: '喜欢的运动',
//         placeholder: '请告诉我你喜欢的运动'
//       }, 
//       pickerAttrs: {
//         title: '选择运动', 
//         valueKey: 'label', // picker选项为对象时，显示值的属性名称，默认为"text",
//         key: 'value', // picker选项为对象时，用于标记值唯一性，用于回显选中值的index，默认为"id",
//       },
//       options: [
//           {
//             label: '游泳',
//             value: 1
//           },
//           {
//             label: '跑步',
//             value: 2
//           },
//           {
//             label: '打球',
//             value: 3
//           },
//           {
//             label: '小孩子才做选择',
//             value: 4
//           }
//       ]
//     },
//        {
//           prop: 'reason',
//           type: 'textarea',
//           defaultValue: '',
//           attrs: {
//             placeholder: '请输入审批意见（选填）',
//             showWordLimit: true,
//             maxlength: 200,
//             rows: 4,
//             inputAlign: "left"
//           }
//         },    
//   ]
// })
